var _path, _g, _path2, _g2, _path3, _g3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#77B3D4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 11C13 11.55 12.55 12 12 12H4C3.45 12 3 11.55 3 11V6C3 5.45 3.45 5 4 5H12C12.55 5 13 5.45 13 6V11Z",
    fill: "#231F20"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10.5C13 11.05 12.55 11.5 12 11.5H4C3.45 11.5 3 11.05 3 10.5V5.5C3 4.95 3.45 4.5 4 4.5H12C12.55 4.5 13 4.95 13 5.5V10.5Z",
    fill: "#E0E0D1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.875 7.55C8.4 7.025 7.6 7.025 7.125 7.55L3.25 10.8C3.2 10.85 3.175 10.9 3.125 10.95C3.3 11.275 3.625 11.5 3.975 11.5H11.975C12.35 11.5 12.65 11.275 12.825 10.95C12.8 10.9 12.75 10.85 12.7 10.8L8.875 7.55Z",
    fill: "#231F20"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.875 8.0125C8.4 7.5375 7.6 7.5375 7.125 8.0125L3.25 10.8875C3.2 10.9375 3.175 10.9625 3.125 11.0125C3.3 11.3125 3.625 11.4875 3.975 11.4875H11.975C12.35 11.4875 12.65 11.2875 12.825 11.0125C12.8 10.9625 12.75 10.9375 12.7 10.8875L8.875 8.0125Z",
    fill: "#E0E0D1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15039 5.05C3.32539 4.725 3.65039 4.5 4.00039 4.5H12.0004C12.3754 4.5 12.6754 4.725 12.8504 5.05C12.8254 5.1 12.7754 5.15 12.7254 5.2L8.87539 8.45C8.40039 8.975 7.60039 8.975 7.12539 8.45L3.15039 5.05Z",
    fill: "#231F20"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12539 8.00625C7.60039 8.48125 8.40039 8.48125 8.87539 8.00625L12.7504 5.13125C12.8004 5.08125 12.8254 5.05625 12.8754 5.00625C12.7004 4.70625 12.3754 4.53125 12.0254 4.53125H4.00039C3.62539 4.53125 3.32539 4.73125 3.15039 5.00625C3.17539 5.05625 3.22539 5.08125 3.27539 5.13125L7.12539 8.00625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAddressIcon);
export default __webpack_public_path__ + "static/media/emailAddressIcon.1f85618b8902512ef94d6ea58b618e58.svg";
export { ForwardRef as ReactComponent };